import { render, staticRenderFns } from "./orderStatementsFilterBox.vue?vue&type=template&id=705e37ae&"
import script from "./orderStatementsFilterBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementsFilterBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports